import { Box, Link, Typography, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const footerLinks = [
  { name: "Landing Page", path: "/" },
  { name: "Login", path: "/Login" },
  { name: "Register", path: "/signup" },
  { name: "Official Profile", path: "/Profile/contactie" },
  { name: "Talent-to-Role Analyzer", path: "https://thisis.my-board.org" },
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "Terms of Service", path: "/terms" },
  { name: "FAQ", path: "/faq" },
];

const SimpleFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: { xs: 2, md: 5 },
        bgcolor: "background.default",
      }}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={{ xs: 1.5, md: 2 }}
        sx={{
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ order: { xs: 2, md: 1 } }}
        >
          © {currentYear}{" "}
          <Link
            href="https://contactie.com/"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            underline="hover"
            color="text.secondary"
          >
            Contactie<sup>™</sup>
          </Link>
        </Typography>

        <Stack
          direction="row"
          spacing={{ xs: 1.5, md: 3 }}
          alignItems="center"
          justifyContent={{ xs: "center", md: "flex-end" }}
          sx={{ flexWrap: "wrap", order: { xs: 1, md: 2 } }}
        >
          {footerLinks.map((link) => {
            const isExternal = link.path.startsWith("http");

            if (isExternal) {
              return (
                <Link
                  key={link.name}
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="body2"
                  underline="hover"
                  color="text.secondary"
                >
                  {link.name}
                </Link>
              );
            }

            return (
              <Link
                key={link.name}
                component={RouterLink}
                to={link.path}
                variant="body2"
                underline="hover"
                color="text.secondary"
              >
                {link.name}
              </Link>
            );
          })}
        </Stack>
      </Stack>
    </Box>
  );
};

export default SimpleFooter;
